import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { ComingSoonBanner } from './components/ComingSoonBanner';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';

import { HomePage } from './pages/HomePage';
import { DocsPage } from './pages/DocsPage';
import { PricingPage } from './pages/PricingPage';
import { SecurityPage } from './pages/SecurityPage';
import { WaitlistPage } from './pages/WaitlistPage';
import { ComparePage } from './pages/ComparePage';
import { TermsPage } from './pages/TermsPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { DpaPage } from './pages/DpaPage';
import { CookiePolicyPage } from './pages/CookiePolicyPage';

// Scroll to top on route change
function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}

export const App: React.FC = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="app-root">
        {/* Pinned Console Banner */}
        <ComingSoonBanner />

        {/* Global Dark Navbar */}
        <Navbar />

        {/* Routes */}
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/docs" element={<DocsPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/compare" element={<ComparePage />} />
          <Route path="/security" element={<SecurityPage />} />
          <Route path="/waitlist" element={<WaitlistPage />} />
          {/* Legal Pages */}
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/dpa" element={<DpaPage />} />
          <Route path="/cookies" element={<CookiePolicyPage />} />
          {/* Fallback to Home */}
          <Route path="*" element={<HomePage />} />
        </Routes>

        {/* Global Light Footer */}
        <Footer />
      </div>
    </BrowserRouter>
  );
};

export default App;
